export default [
  {
    path: '/dkp-clientes-tokens',
    name: 'dkp-clientes-tokens-list',
    component: () => import('@/views/clientes-dkp/cliente-token/list/Index.vue'),

    meta: {
      pageTitle: 'Clientes Tokens',
      actions: 'manage',
      resource: 'all',
    },
  },
];
